module.exports = __webpack_public_path__ + "assets/images/novasport_4.4c626cd8485532103de9e156c150ab92.png";